
import { callApiWithAuthorization } from "../CallApi";

export const cloneProject = async (project, organization, cloneFromOrganizationId, isCloningTenantApp = false, instanceId = null) => {
    if (project.isActive === undefined) {
        return {
            status: "failure",
            type: "validate",
            error: {
                isValid: false,
                message: "App you trying to install doesn't exist"
            }
        }
    }
    if (project.isActive === false) {
        return {
            status: "failure",
            type: "validate",
            error: {
                isValid: false,
                message: "App you trying to install is not active anymore"
            }
        }
    }
    if (project._id && project.isActive === true) {
        try {
            const url = "/api/v0/CopyProject/" + organization._id + "/" + project._id + "/" + cloneFromOrganizationId;
            const request = await callApiWithAuthorization(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    isCloningTenantApp: isCloningTenantApp,
                    instanceId: instanceId,
                })
            })
            const response = await request.json();
            if (response.status === "success") {
                return response;
            } else if (response.type === "upgrade") {
                return {
                    status: "failure",
                    type: "upgrade",
                    error: {
                        isValid: false,
                        message: response.error
                    }
                }
            } else {
                return {
                    status: "failure",
                    type: "validate",
                    error: {
                        isValid: false,
                        message: response.error
                    }
                }
            }
        } catch (e) {
            return {
                status: "failure",
                type: "validate",
                error: {
                    isValid: false,
                    message: e.message
                }
            }
        }
    }
}

export const getProject = async (projectId) => {
    const request = await callApiWithAuthorization("/api/v0/project/" + projectId);
    const response = await request.json();
    return response;
}

export const updateProject = async (projectId, properties) => {
    const request = await callApiWithAuthorization("/api/v0/project/" + projectId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    const response = await request.json();
    return response;
}

export const updateAdvanceModeInProject = async (organizationId) => {
    const request = await callApiWithAuthorization(`/api/v0/updateAdvanceModeInProject/${organizationId}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        }
    })
    const response = await request.json();
    return response;
}

export const deleteProject = async (projectId) => {
    const request = await callApiWithAuthorization("/api/v0/project/delete/" + projectId, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
    });
    const response = await request.json();
    return response;
}

export const deleteProjectFromDesigner = async (projectId) => {
    let projectDeleteRequest = await callApiWithAuthorization("/api/v0/project/delete/" + projectId, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
    });
    let projectDeleteResponse = await projectDeleteRequest.json();
    return projectDeleteResponse;
}

export async function createCopyOfProject(projectId) {
    const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/createClone", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        }
    });
    const response = await request.json();
    return response;
}

export async function getOrganisationProjects(organisationId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organisationId + "/projects");
    const response = await request.json();
    return response;
}

export async function updateProjectInstance(projectId, instanceId, properties) {
    const request = await callApiWithAuthorization('/api/v0/project/' + projectId + '/instance/' + instanceId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    const response = await request.json();
    return response;
}

export async function getAppUserAndRoles(organizationId) {
    const accessToken = localStorage.getItem("accessToken");
    const request = await callApiWithAuthorization("/api/v0/getOrgUserRoles/" + organizationId, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + accessToken,
        }
    });
    const response = await request.json();
    return response;
}

export async function updateLabelsForSchema(projectId, properties) {
    const request = await callApiWithAuthorization('/api/v0/project/' + projectId + '/updateLabelsForSchema', {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    const response = await request.json();
    return response;
}

export async function updateProjectPropertiesAfterPublish(projectId, instanceId) {
    await updateProjectInstance(projectId, instanceId, { Published: true, isDbChanged: false })
    await updateProject(projectId, { hasSchemaChanges: false })
}